import {
  APP_ID,
  AUTH_TOKEN,
  STORE_INFO,
  CHECK_USER_COVERAGE_AREA_SUPPORT,
  GET_QATAR_ZONES,
  EHttpMethods,
} from "../constants";
import { getCookie } from "../utils";
import type { ICity } from "../components/Address/AddressForm/address-form.interface";

type IAssortmentAreaInfo = Record<string, string[]>;

interface IAddressZoneResponse {
  data: {
    country: string;
    cities: ICity[];
  };
}

interface ICoverageResponse {
  assortmentAreaInfo: IAssortmentAreaInfo;
  isSupported: boolean;
}

export const checkUserCoverageAreaSupport = async (
  lat: string,
  lng: string,
): Promise<ICoverageResponse> => {
  const authToken = getCookie(AUTH_TOKEN);
  const storeInfo = getCookie(STORE_INFO);
  if (!storeInfo) {
    throw new Error("Store information is missing");
  }
  const [storeId, langCode] = storeInfo.split("|");

  const token = authToken ? `Bearer ${authToken}` : "";
  const params = new URLSearchParams({ latitude: lat, longitude: lng });

  const url = `${CHECK_USER_COVERAGE_AREA_SUPPORT.replace("{{storeId}}", storeId).replace("{{langCode}}", langCode)}?${params.toString()}`;

  const response = await fetch(url, {
    method: EHttpMethods.Get,
    headers: {
      Authorization: token,
      appId: APP_ID,
    },
  });

  const data: ICoverageResponse = (await response.json()) as ICoverageResponse;
  return data;
};

export const getAddressZone = async (): Promise<IAddressZoneResponse> => {
  const authToken = getCookie(AUTH_TOKEN);
  const token = authToken ? `Bearer ${authToken}` : "";
  const storeInfo = getCookie(STORE_INFO);
  if (!storeInfo) {
    throw new Error("Store information is missing");
  }
  const [storeId, langCode] = storeInfo.split("|");
  const params = "country=QA";
  const url = `${GET_QATAR_ZONES}?${params}`;
  try {
    const response = await fetch(url, {
      method: EHttpMethods.Get,
      headers: {
        Authorization: token,
        appId: APP_ID,
        langCode,
        storeId,
      },
    });
    return response.json() as Promise<IAddressZoneResponse>;
  } catch (error) {
    // eslint-disable-next-line no-console -- logger
    console.error("Error fetching address zone:", error);
    throw error;
  }
};
